import styled from "styled-components";

export const StyledSize = styled.section`
  .flex-size {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }

  span {
    font-size: 12px;
    color: #749be8;
    font-weight: 700;
    margin-left: 10px;
  }
`;
